/**
 * RTCPeerConnection config for outgoing/answer sessions.
 *
 * Do not add STUN/TURN here while JsSIP waits for full ICE gathering before INVITE
 * (`_createLocalDescription`). An unreachable stun:<host>:3478 delayed INVITE ~1 min
 * (WUI-5868 regression vs 2.6.3). Re-enable only with trickle / early ready().
 */
export const getPcConfig = (): RTCConfiguration => ({
  bundlePolicy: 'max-bundle',
})
